<!-- Main content starts from here -->
<div class="content__wrapper" *ngIf="!isDataLoading" id="stdDownloadLoading">
  <div class="card download_std_ipos" id="downloadStdIpos">
    <div class="card-header" id="stdCardHeader">
      <div class="title" id="stdIposHeading">{{globalconst.STD_IPOS_HEADING}}</div>
      <div class="mt-2" id="stdIposTitleMainDiv">
        <div id="stdIposTitleChildDiv">
          <span>{{globalconst.STD_IPOS_TITLE}}</span>
        </div>
        <div id="selectedPkgDownload"><span i18n="@@standard-download.select-package-download">Select a Package to download.</span></div>
      </div>
    </div>
    <div class="card-body" id="pkgCardBody">
      <div class="package_note_container" id="pkgNoteContainer">
        <div class="package_note" [ngClass]="{'czech-width':isRussian || isCzech, 'hungarian-width':isHungarian || isItalian || isJapanese || isSpanish, 
          'greek-width':isGreek || isFrench || isKorean || isNorwegian || isSpanishMexico || isUkraine}" id="pkgNote">
          <div class="package_note_img" id="pkgNoteImg"><img class="star_note_icon" alt="star note" /></div>
          <div class="package_note_text" id="pkgNoteText" i18n="@@standard-download.non-custom-package-ms-profile">These Non-Custom packages
            contain MS Profiles by default</div>
        </div>
      </div>
      <div class="download_cards" id="stdDownloadCards">
        <!-- CHINA LITE  -->
        <div class="custom-card firstCard p-4" id="customCardChinaLite" *ngIf="isIposChinaEnabled">
          <div class="d-flex-parent" id="cardParentFlexChinaLite">
            <div class="d-flex" id="cardDFlexChinaLite">
              <div class="download_ipos-lite_image" id="downloadChinaLiteImg"></div>
              <div class="details-conatiner" id="detailsConChinaLite" [ngClass]="{'rtl-margin': isArabic || isHebrew}">
                <div class="custom-card-header" id="customCardHeaderChinaLite">
                  <div id="chinaLiteTitleDiv">{{iposChina_title}}</div>
                </div>
                <div id="chinaLiteDesc">
                  <span>{{iposChina_desc}}</span>
                </div>
              </div>
            </div>
            <div *ngIf="showProductmapping" class="languageDiv add-template" [ngClass]="PMFileExists ? 'adjust-add-template' : ''"
              tooltipClass="upload-template-tooltip" id="productMapping" placement="right"
              [ngbTooltip]="addTemplateTooltip" [autoClose]="false" #addTemplate="ngbTooltip" triggers="manual">
              <button type="button" class="add_template_btn" (click)="openUploadTemplate()" aria-haspopup="true" aria-expanded="false">
                {{addTemplateText}}
              </button>
              <div class="file-name-grp" *ngIf="PMFileExists">
                <button class="btn btn-outline-primary file-name">
                  <span>{{templateName}}</span>
                </button>  
                <div class="download_icon" [ngbTooltip]="downloadMessage" triggers="hover" placement="bottom"
                  (click)="downloadModifiedTemplate()"></div>
              </div>
              <div *ngIf="PMFileExists">
                <span class="upload-date">
                  <span i18n="@@standard-download.ipos-lite.last-updated-on">Last updated on</span>
                  {{uploadedDate | dateFormat: "changeToLocalTimeZone"}}</span>
              </div>
              <ng-template #downloadMessage>
                <span>{{clickHereDownload}}</span>
              </ng-template>
              <ng-template #addTemplateTooltip>
                <div class="upload-template-tooltip-header">
                  <div class="upload-icon-and-text">
                    <div class="upload-icon"></div>
                    <span>{{uploadTemplateText}}</span>
                  </div>
                  <div (click)="closeUploadModal()" class="close-icon"></div>
                </div>
                <div class="upload-template-tooltip-body">
                  <p><strong>1.</strong>&nbsp; <span>{{stepToDownloadOne}}</span>
                    <br><span><a (click)="downloadPMFile()" class="download_template_link">{{downloadTemplateText}}</a></span>
                  </p>
                  <p><strong>2.</strong>&nbsp;<span i18n="@@stores.store-user.csv-upload-comp-template">Upload and submit the completed template:</span>
                    <br>&nbsp;<span>{{templateNoteText}}</span>
                  </p>
                  <label class="upload-margin">
                    <input #templateInput type="file" id="file-picker" accept=".xlsx" (change)="onFilechange($event)" hidden />
                    <span class="btn btn-primary upload-btn-grp">
                      <span class="upload_cloud_white_icon"></span>
                      <span i18n="@@standard-download.ipos-lite.upload-template">Upload Template</span>
                    </span>
                  </label>
                  <div *ngIf="showXlsxError" id="errorMsgFormat">
                    <span class="text-danger" i18n="@@standard-download.ipos-lite.file-in-xlsx">File must be in .xlsx format.</span>
                  </div>
                  <div *ngIf="showFileContentError" id="errorMsgName">
                    <span class="text-danger" i18n="@@standard-download.ipos-lite.file-content-not-match">File contents not matching.</span>
                  </div>
                  <div class="div-alert">
                    <span class="alert-box" i18n="@@standard-download.ipos-lite.click-on-upload-template">Clicking on <a>Upload template</a> will replace the existing product mapping file!</span>
                  </div>                
                </div>
              </ng-template>
            </div>
          </div>
          <div class="button-container" id="prepareBtnTextChinaLite">
            <button *ngIf="[globalconst.GENERATE_VAL, globalconst.DOWNLOAD_VAL].indexOf(prepareBtnText(iposLite)) > -1"
              (click)="decideTheClick(iposLite, windowExt,iposLite,iposLite)"
              [ngClass]="prepareBtnText(iposLite) === globalconst.DOWNLOAD_VAL ? 'btn btn-primary' :'btn btn-outline-primary'">
              {{translatedVal[prepareBtnText(iposLite)]}}
            </button>
            <div class="pb-block" *ngIf="prepareBtnText(iposLite) === globalconst.GENERATING_VAL">
              <div class="pb-widget" *ngIf="isStandard"
                [ngStyle]="{'background':getProgressbarBgColor(preparePbValue(iposLite))}">
                <div class="pb-values">{{preparePbValue(iposLite)}}%</div>
              </div>
              <em *ngIf="prepareBtnText(iposLite) === globalconst.GENERATING_VAL && !isStandard"
                class="spinner-border text-primary"></em>
              &nbsp;<span class="pb-text" [innerHTML]="translatedVal[prepareBtnText(iposLite)]"></span>
            </div>
          </div>
        </div>
        <!-- Standard IPOS Download -->
        <div class="custom-card firstCard p-4" id="customCard">
          <div class="d-flex-parent" id="customCardFlex">
            <div class="d-flex" id="customCardDFlex">
              <div class="package_note_img_card" id="pkgNoteImgCardStd"><img class="star_note_icon" alt="star note" /></div>
              <div class="download_std_image" id="downloadSTDImg"></div>
              <div class="details-conatiner" id="containerDetails" [ngClass]="{'rtl-margin': isArabic || isHebrew}">
                <div class="custom-card-header" id="customCardHeader">
                  <div class="std_header_icon header_icon" id="stdHeaderIcon"></div>
                  <div id="mainStreamHeading">{{globalconst.MAIN_STREAM_HEADING}}</div>
                </div>
                <div id="mainStreamSubtext">
                  <span>{{globalconst.MAIN_STREAM_SUBTEXT}}</span>
                </div>
              </div>
            </div>
            <div class="languageDiv" id="languageDiv">
              <ng-select [items]="languageJSON" placeholder="{{selectLangConst}}" bindLabel="langName" [clearable]="false"
                [(ngModel)]="pkgMetaData.standard.langObject" [ngModelOptions]="{standalone: true}" [selectOnTab]="true"
                (change)="getSelectedLanguage($event, 'standard')">
              </ng-select>
            </div>
          </div>
          <div class="button-container" id="btnContainer">
            <button *ngIf="[globalconst.GENERATE_VAL, globalconst.DOWNLOAD_VAL].indexOf(prepareBtnText('standard')) > -1" (click)="decideTheClick(windowsOS, windowExt, STANDARD,'standard')"
              [ngClass]="prepareBtnText('standard') === globalconst.DOWNLOAD_VAL ? 'btn btn-primary' :'btn btn-outline-primary'">
              {{translatedVal[prepareBtnText('standard')]}}
            </button>
            <div class="pb-block" *ngIf="prepareBtnText('standard') === globalconst.GENERATING_VAL">
              <div class="pb-widget" *ngIf ="isStandard" [ngStyle]="{'background':getProgressbarBgColor(preparePbValue('standard'))}">
                <div class="pb-values">{{preparePbValue('standard')}}%</div>
              </div>
              <em *ngIf="prepareBtnText('standard') === globalconst.GENERATING_VAL && !isStandard "class="spinner-border text-primary"></em>
              &nbsp;<span class="pb-text" [innerHTML]="translatedVal[prepareBtnText('standard')]"></span>
            </div>
          </div>
        </div>
        <!-- UWP Standard IPOS Download -->
        <div class="custom-card firstCard p-4" id="uwpStdIposDownloadCard">
          <div class="d-flex-parent" id="uwpStdFlexParent">
            <div class="d-flex" id="uwpStdFlexParentChild">
              <div class="uwp_header_icon" id="uwpHeaderIcon"></div>
              <div class="details-conatiner" id="uwpDetailsContainer" [ngClass]="{'rtl-margin': isArabic || isHebrew}">
                <div class="custom-card-header" id="customeCardHeader">
                  <div class="std_header_icon header_icon" id="uwpStdHeader"></div>
                  <div id="uwpHeading">{{globalconst.UWP_HEADING}}</div>
                </div>
                <div id="uwpSubText">
                  <span>{{globalconst.UWP_SUBTEXT}}</span>
                </div>
              </div>
            </div>
            <div class="languageDiv" id="languageDivUwp">
              <ng-select [items]="languageJSON" placeholder="{{selectLangConst}}" 
                  bindLabel="langName" [clearable]="false" 
                  [(ngModel)]="pkgMetaData.uwp.langObject" [ngModelOptions]="{standalone: true}" [selectOnTab]="true" 
                  (change)="getSelectedLanguage($event,'uwp')">
              </ng-select>
            </div>
          </div>
          <div class="button-container" id="btnContainerUwp">
            <button *ngIf="[globalconst.GENERATE_VAL, globalconst.DOWNLOAD_VAL].indexOf(prepareBtnText('uwp')) > -1" (click)="decideTheClick(windowsOS, windowExt, 'uwp','uwp')" 
              [ngClass]="prepareBtnText('uwp') === globalconst.DOWNLOAD_VAL ? 'btn btn-primary' :'btn btn-outline-primary'">
              {{translatedVal[prepareBtnText('uwp')]}}
            </button>
            <div class="pb-block" *ngIf="prepareBtnText('uwp') === globalconst.GENERATING_VAL">
              <div class="pb-widget"  *ngIf ="isStandard" [ngStyle]="{'background':getProgressbarBgColor(preparePbValue('uwp'))}">
                <div class="pb-values">{{preparePbValue('uwp')}}%</div>
              </div>
              <em *ngIf="prepareBtnText('uwp') === globalconst.GENERATING_VAL && !isStandard "class="spinner-border text-primary"></em>
              &nbsp;<span class="pb-text" [innerHTML]="translatedVal[prepareBtnText('uwp')]"></span>
            </div>
          </div>
        </div>
        <!-- gaming  -->
        <div class="custom-card firstCard p-4" id="customCardGaming">
          <div class="d-flex-parent" id="customCardFlexParent">
            <div class="d-flex" id="customCardFlex">
              <div class="package_note_img_card" id="pkgNoteImgCardGaming"><img class="star_note_icon" alt="star note" /></div>
              <div class="download_gaming_image" id="downloadGamingImg"></div>
              <div class="details-conatiner" id="detailsContainer" [ngClass]="{'rtl-margin': isArabic || isHebrew}">
                <div class="custom-card-header" id="customCardHeaderGaming">
                  <div class="winten_header_icon header_icon" id="wintenHeaderGaming"></div>
                  <div i18n="@@standard-download.gaming.gaming-title" id="stdGamingTitle">GAMING</div>
                </div>
                <div class="lineHeight" id="gamingDescLineHeight">
                  <span i18n="@@standard-download.gaming.gaming-desc">Gaming associated content, includes a game demo</span>
                  <div id="gamingDemoCss" i18n="@@standard-download.additional-gamedemos-use-with-ipos">
                    <a class="btn-link" (click)="enableGameDemo(content)">Download</a> additional game demos 
                    for use with IPOS</div>
                </div>
              </div>
            </div>
            <div class="languageDiv" id="languageGaming">
              <ng-select [items]="languageJSON" placeholder="{{selectLangConst}}" 
                  bindLabel="langName" [clearable]="false" 
                  [(ngModel)]="pkgMetaData.gaming.langObject" [ngModelOptions]="{standalone: true}" [selectOnTab]="true" 
                  (change)="getSelectedLanguage($event, 'gaming')">
              </ng-select>
            </div>
          </div>  
          <div class="button-container " id="btnContainerGaming">
              <button *ngIf="[globalconst.GENERATE_VAL, globalconst.DOWNLOAD_VAL].indexOf(prepareBtnText('gaming')) > -1" (click)="decideTheClick(windowsOS, windowUWPExt, GAMING,'gaming')" 
                [ngClass]="prepareBtnText('gaming') === globalconst.DOWNLOAD_VAL ? 'btn btn-primary' :'btn btn-outline-primary'">
                {{translatedVal[prepareBtnText('gaming')]}}
              </button>
              <div class="pb-block" *ngIf="prepareBtnText('gaming') === globalconst.GENERATING_VAL">
                <div class="pb-widget" *ngIf ="isStandard" [ngStyle]="{'background':getProgressbarBgColor(preparePbValue('gaming'))}">
                  <div class="pb-values">{{preparePbValue('gaming')}}%</div>
                </div>
                <em *ngIf="prepareBtnText('gaming') === globalconst.GENERATING_VAL && !isStandard "class="spinner-border text-primary"></em>
                &nbsp;<span class="pb-text" [innerHTML]="translatedVal[prepareBtnText('gaming')]"></span>
              </div>
          </div>
        </div>
        <!-- creator , Creator removed as per IIT2-21864 -->
        <!-- <div class="custom-card firstCard p-4" id="customeCardCreator">
          <div class="d-flex-parent" id="cardFlexCreator">
            <div class="d-flex" id="customCreatorDFlex">
              <div class="package_note_img_card" id="pkgNoteImgCard"><img class="star_note_icon" alt="star note" /></div>
              <div class="download_creator_image" id="downloadCreatorImage"></div>
              <div class="details-conatiner" id="detailsContainerCreator" [ngClass]="{'rtl-margin': isArabic || isHebrew}">
                <div class="custom-card-header" id="cardHeaderCreator">
                  <div class="creator_header_icon header_icon" id="creatorHeaderIcon"></div>
                  <div i18n="@@standard-download.creator.creator-title" id="creatorTitle">CREATOR</div>
                </div>
                <div id="creatorDescDiv">
                  <span i18n="@@standard-download.creator.creator-desc">Highlights the creative capabilities of
                    devices.</span>
                </div>
              </div>
              
            </div>
            <div class="languageDiv" id="pkgMetaDataCreator">
              <ng-select [items]="languageJSON" placeholder="{{selectLangConst}}" 
                  bindLabel="langName" [clearable]="false" 
                  [(ngModel)]="pkgMetaData.creator.langObject" [ngModelOptions]="{standalone: true}" [selectOnTab]="true" 
                  (change)="getSelectedLanguage($event,'creator')">
              </ng-select>
            </div>
          </div>  
          <div class="button-container " id="prepareBtnTextCreator">
              <button *ngIf="[globalconst.GENERATE_VAL, globalconst.DOWNLOAD_VAL].indexOf(prepareBtnText('creator')) > -1" (click)="decideTheClick(creatorOS, windowUWPExt,'Creator','creator')" 
                [ngClass]="prepareBtnText('creator') === globalconst.DOWNLOAD_VAL ? 'btn btn-primary' :'btn btn-outline-primary'">
                {{translatedVal[prepareBtnText('creator')]}}
              </button>
              <div class="pb-block" *ngIf="prepareBtnText('creator') === globalconst.GENERATING_VAL">
                <div class="pb-widget" *ngIf ="isStandard" [ngStyle]="{'background':getProgressbarBgColor(preparePbValue('creator'))}">
                  <div class="pb-values">{{preparePbValue('creator')}}%</div>
                </div>
                <em *ngIf="prepareBtnText('creator') === globalconst.GENERATING_VAL && !isStandard "class="spinner-border text-primary"></em>
                &nbsp;<span class="pb-text" [innerHTML]="translatedVal[prepareBtnText('creator')]"></span>
              </div>
          </div>
        </div> -->
        <!-- linux ISO -->
        <div class="custom-card firstCard p-4" id="customLinuxISOCard">
          <div class="d-flex-parent" id="customFlexParent">
            <div class="d-flex" id="customDFlexLinux">
              <div class="download_linux_image" id="downloadLinuxImg"></div>
              <div class="details-conatiner" id="detailsConLinuxISO" [ngClass]="{'rtl-margin': isArabic || isHebrew}">
                <div class="custom-card-header" id="cardHeaderLinuxISO">
                  <div class="linux_header_icon header_icon" id="linuxHeaderIcon"></div>
                  <div>{{globalconst.STANDARD_PACKAGE_LINUX_ISO}}</div>
                </div>
                <div id="linuxDescDiv">
                  <span i18n="@@standard-download.linux.linux-desc">Available for bare-bones IPOS machines. (For PCs
                    without an OS)</span>
                </div>
              </div>
            </div>
            <div class="languageDiv" id="pkgMetaDataISOLangObject">
              <ng-select [items]="languageJSON" placeholder="{{selectLangConst}}" 
                  bindLabel="langName" [clearable]="false" 
                  [(ngModel)]="pkgMetaData.iso.langObject" [ngModelOptions]="{standalone: true}" [selectOnTab]="true" 
                  (change)="getSelectedLanguage($event,'iso')">
              </ng-select>
            </div>
          </div>  
          <div class="button-container " id="prepareBtnTextISO">
              <button *ngIf="[globalconst.GENERATE_VAL, globalconst.DOWNLOAD_VAL].indexOf(prepareBtnText('iso')) > -1" (click)="decideTheClick(linuxOS, '','','iso')" 
                [ngClass]="prepareBtnText('iso') === globalconst.DOWNLOAD_VAL ? 'btn btn-primary' :'btn btn-outline-primary'">
                {{translatedVal[prepareBtnText('iso')]}}
              </button>
              <div class="pb-block" *ngIf="prepareBtnText('iso') === globalconst.GENERATING_VAL">
                <div class="pb-widget" *ngIf ="isStandard" [ngStyle]="{'background':getProgressbarBgColor(preparePbValue('iso'))}">
                  <div class="pb-values">{{preparePbValue('iso')}}%</div>
                </div>
                <em *ngIf="prepareBtnText('iso') === globalconst.GENERATING_VAL && !isStandard "class="spinner-border text-primary"></em>
                &nbsp;<span class="pb-text" [innerHTML]="translatedVal[prepareBtnText('iso')]"></span>
              </div>
          </div>
        </div>
        <!-- linux  ISO Appln-->
        <div class="custom-card firstCard p-4" id="customCardLinuxISO">
          <div class="d-flex-parent" id="customFlexParent">
            <div class="d-flex" id="customDFlexLinusISO">
              <div class="download_linux_image" id="downloadLinuxImgISO"></div>
              <div class="details-conatiner" id="detailsLinuxISOCon" [ngClass]="{'rtl-margin': isArabic || isHebrew}">
                <div class="custom-card-header" id="customCardHeaderLinux">
                  <div class="linux_header_icon header_icon" id="stndPkgLinuxHeaderIcon"></div>
                  <div id="stndPkgLinuxIPOSAppln">{{globalconst.STANDARD_PACKAGE_LINUX_IPOS}}</div>
                </div>
                <div id="linuxIposSubTextAppln">
                  <span >{{globalconst.LINUX_IPOS_SUBTEXT}}</span>
                </div>
              </div>
            </div>
            <div class="languageDiv" id="pkgMetaDataSelectedLang">
              <ng-select [items]="languageJSON" placeholder="{{selectLangConst}}" 
                  bindLabel="langName" [clearable]="false" 
                  [(ngModel)]="pkgMetaData.deb.langObject" [ngModelOptions]="{standalone: true}" [selectOnTab]="true" 
                  (change)="getSelectedLanguage($event,'deb')">
              </ng-select>
            </div>
          </div>  
          <div class="button-container " id="prepareBtnTexDeb">
              <button *ngIf="[globalconst.GENERATE_VAL, globalconst.DOWNLOAD_VAL].indexOf(prepareBtnText('deb')) > -1" (click)="decideTheClick(linuxOS, '','','deb')" 
                [ngClass]="prepareBtnText('deb') === globalconst.DOWNLOAD_VAL ? 'btn btn-primary' :'btn btn-outline-primary'">
                {{translatedVal[prepareBtnText('deb')]}}
              </button>
              <div class="pb-block" *ngIf="prepareBtnText('deb') === globalconst.GENERATING_VAL">
                <div class="pb-widget" *ngIf ="isStandard" [ngStyle]="{'background':getProgressbarBgColor(preparePbValue('deb'))}">
                  <div class="pb-values">{{preparePbValue('deb')}}%</div>
                </div>
                <em *ngIf="prepareBtnText('deb') === globalconst.GENERATING_VAL && !isStandard "class="spinner-border text-primary"></em>
                &nbsp;<span class="pb-text" [innerHTML]="translatedVal[prepareBtnText('deb')]"></span>
              </div>
          </div>
        </div>
        <!-- chrome  -->
         <div class="custom-card firstCard p-4" id="customCardChrome">
          <div class="d-flex-parent" id="cardParentFlexChrome">
            <div class="d-flex" id="cardDFlexChrome">
              <div class="download_chromebook_image" id="downloadChromeBookImg"></div>
              <div class="details-conatiner" id="dtailsConChrome" [ngClass]="{'rtl-margin': isArabic || isHebrew}">
                <div class="custom-card-header" id="customCardHeaderChrome">
                  <div class="chromebook_header_icon header_icon" id="chromeBookHeaderIcon"></div>
                  <div id="chromeBookTitleDiv">{{chromebook_title}}</div>
                </div>
                <div id="chromeBookDesc">
                  <span>{{chromebok_desc}}</span>
                </div>
              </div>
            </div>
            <div class="languageDiv" id="selectChromeBookLang">
              <ng-select [items]="chromelanguageJSON" placeholder="{{selectLangConst}}"
                  bindLabel="langName" [clearable]="false" 
                  [(ngModel)]="pkgMetaData.chromebook.langObject" [ngModelOptions]="{standalone: true}" [selectOnTab]="true" 
                  (change)="getSelectedLanguage($event,'chromebook')">
              </ng-select>
            </div>
          </div>
          <div class="button-container " id="prepareBtnTextChromeBook">
            <button *ngIf="[globalconst.GENERATE_VAL, globalconst.DOWNLOAD_VAL].indexOf(prepareBtnText('chromebook')) > -1" (click)="decideTheClick(windowsOS, windowExt,CHROME,'chromebook')" 
              [ngClass]="prepareBtnText('chromebook') === globalconst.DOWNLOAD_VAL ? 'btn btn-primary' :'btn btn-outline-primary'">
              {{translatedVal[prepareBtnText('chromebook')]}}
            </button>
            <div class="pb-block" *ngIf="prepareBtnText('chromebook') === globalconst.GENERATING_VAL">
              <div class="pb-widget" *ngIf ="isStandard" [ngStyle]="{'background':getProgressbarBgColor(preparePbValue('chromebook'))}">
                <div class="pb-values">{{preparePbValue('chromebook')}}%</div>
              </div>
              <em *ngIf="prepareBtnText('chromebook') === globalconst.GENERATING_VAL && !isStandard "class="spinner-border text-primary"></em>
              &nbsp;<span class="pb-text" [innerHTML]="translatedVal[prepareBtnText('chromebook')]"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container" id="containerSTDDownload">
  <div class="modal-dialog-centered" *ngIf="openModalPopup" id="modalDialogInstallationPkg">
    <div class="modal-backdrop show" id="modalBackdropInstall"></div>
    <div class="modal" id="myModal">
      <div class="modal-dialog lang_modal" id="myModalInstallPkgIPOS">
        <div class="modal-content" id="myModalContentInstallPkg">
          <div _ngcontent-fjy-c198="" class="close" (click)="closeModal()" id="myModalCloseInstallPkg">
            <img _ngcontent-fjy-c198="" alt="close" class="modal-close-icon">
          </div>
          <div class="modal-body lang_content pb-0" id="modalBodyInstallPkg">

            <div class="header d-flex" id="headerDFlexInstallPkg">
              <span class="lang_image"></span>
              <h5 class="heading_language" [innerHTML]="languageHeading"></h5>
            </div>
            <div class="mb-3" id="downloadSelectInstallPkg">
              <span i18n="@@standard-download.select-installation-package">Select the language of your IPOS Installation
                Package.</span>
            </div>
            <div class="search_group" id="searchGrpMainDiv">
              <div class="input-group" id="searchGrpInput">
                <input #searchValue type="text" autocomplete="off" class="form-control search-box"
                  [(ngModel)]="searchData" placeholder="{{searchLanguageName}}" (keyup.enter)="searchLanguage()" />
                <img alt="close" *ngIf="searchClose" (click)="clearSearch()" class="search-clear-icon">
              </div>
              <button type="button" class="btn btn-primary ml-2 gtmLanguageSearch" (click)="searchLanguage()">
                <span class="search_icon"></span>
              </button>

            </div>

            <div class="scroll_section mt-3" id="langScrollSection">
              <form [formGroup]="langForm" class="dropdownscroll" ngbRadioGroup>
                <div class="card-body pl-0 pr-0 pt-0" id="cardBodyScrollSection">
                  <label for="{{ language.langInEng }}" class="lang_radiobtn"
                    *ngFor="let language of languageJSON; trackBy: trackByLanguage">
                    {{ language.langName }}
                    <input type="radio" name="langRadios" id="{{ language.langName }}" [value]='language.langName'
                      (click)="setButtonText(language.langName, language.langCode)" [checked]="language.checked" />
                  </label>

                </div>
              </form>
            </div>


          </div>
          <div class='modal-footer' id="modalFooterPkgBtnName">
            <button class='btn btn-outline-primary btn-md' (click)="closeModal()">{{cancelBtnName}}</button>
            <button class='btn btn-primary btn-md' (click)='downloadStdPackage()' *ngIf="!isStandard">
              {{downloadPackageName}}
            </button>
            <button class='btn btn-primary btn-md' (click)="generatePackage()" *ngIf="isStandard">
              {{generateBtnName}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-dialog-centered" *ngIf="openProgressPopup" id="modalOpenProgress">
    <div class="modal-backdrop show" id="modalBackdropOpenProgress"></div>
    <div class="modal" id="myModal">
      <div class="modal-dialog" id="myModalOpenProgressDialog">
        <div class="modal-content " id="myModalOpenProgressCon">
          <div class="modal-body contentCentered" id="myModalOpenProgress">
            <span class="custom-spinner-border"></span>
            <!-- <img src="../../../../assets/images/generate_package_icon" /> -->
            <div class="downloadFilename pt-2" id="pkgProgressTitleFileName">
              {{packageProgressTitle}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-dialog-centered" *ngIf="showDownloadPopup" id="showDownloadModalDialog">
    <div class="modal-backdrop show" id="modalBackdropShowDownload"></div>
    <div class="modal" id="myModal3">
      <div class="modal-dialog newDownloadPopup" id="newDownloadPopup">
        <div class="modal-content" id="myModal3Content">
          <div _ngcontent-fjy-c198="" class="close" (click)="closeModal()" id="myModal3Close">
            <img _ngcontent-fjy-c198="" alt="close" class="modal-close-icon">
          </div>
          <div class="modal-body lang_content pb-3" *ngIf="downloadPopUpData?.length" id="myModal3Body">

            <div class="header d-flex downloadPHeading" id="downloadHeaderFlex">
              <h1 class="mb-0" [innerHTML]="globalconst.DWNLD_POPUP_TITLE"></h1>
            </div>
            <div class="separator mt-2 mb-3" id="separatorDiv"></div>
            <div class="mb-3" *ngIf="isGamingMessage" id="isGamingPkgMsgText">{{gamingPackageMsgText}}</div>
            <div class="d-flex" id="downloadFileNameDFlex">
              <div class="mr-auto mt-1 column" id="downloadFileNameColumn">
                <div class="downloadFilename" id="downloadPopupDataFileName">
                  {{downloadPopUpData[0]?.fileName}}
                </div>
                <div *ngIf="isStandard" id="isCheckingStd">
                  <span i18n="@@active-device-report.last-generated-on">Last generated on  {{downloadPopUpData[0]?.updatedTime | dateFormat: "shortDateFormat"}}.</span>
                </div>
              </div>
              <div id="downloadBtnText">
                <button class="btn btn-primary" (click)="downloadPackage()">{{downloadBtnText}}</button>
              </div>
            </div>
            <div class="form-group mt-4 mb-3" id="shareURLNameFrmGrp">
              <label for="sharePackageLink">{{globalconst.SHARE_URL_NAME}}</label>:
              <div class="inline_fields" id="shareURLInlineFields">
                <div class="row" id="shareUrlRow">
                  <div class="col-7" id="sharePackageLinkCol7">
                    <input class="form-control" readonly id="sharePackageLink" #inputToBeCopied
                  value="{{downloadPopUpData[0].downloadURL}}" />
                  </div>
                  <div class="col-3" id="gtmCopyDownloadUrlCol3">
                    <button class="btn btn-outline-primary gtmCopyDownloadUrl" (click)="copyPackageURL(inputToBeCopied)">{{globalconst.COPY_TEXT_NAME}}</button>
                  </div>
                  <div class="col-2" id="shareURLNameCol2"></div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-dialog-centered" *ngIf="selectlinuxospackagePopup" id="selectLinuxPkgPopup">
  <div class="modal-backdrop show" id="modalLinuxBackDrop"></div>
  <div class="modal" id="myModal">
    <div class="modal-dialog generatePopup" id="myModalGeneratePopup">
      <div class="modal-content" id="myModalContentGenerate">
        <div class="card" id="generatePopupCard">
          <div class="modal-header rm-border" id="generatePopupHeader">
            <div class="invitesuccessmodal-close-icon" data-dismiss="modal" (click)="onCloseSelectPackagePopup()" id="inviteSuccessModalCloseIcon"></div>
          </div>
          <div class="modal-body invitesuccess-panel" id="inviteSuccessPanel">
            <div class="invitesuccess-title text-left" id="generatePkgSelectTitle">
              {{generatePackageSelectTitle}}
            </div>
            <div class="mt-c3 invitesuccess-content text-center" id="inviteSuccessConLinuxIso">
              <button class="btn-primary btn-lg gtmCreateProfDownloadPackage" (click)="onGenerateLinuxISO(1)">
                {{generatePackageSelectLinuxiso}}
              </button>
            </div>
            <div class="mt-c3 invitesuccess-content text-center" id="inviteSuccessConTxtCenter">
              <button class="btn-primary btn-lg gtmCreateProfDownloadPackage" (click)="onGenerateLinuxISO(2)">
                {{generatePackageSelectLinuxipos}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #content>
  <div class="modal-dialog-centered" id="gameDemosPopup" ngbAutofocus>
    <div class="modal-backdrop show" id="modalLinuxBackDrop"></div>
    <div class="modal" id="myModal">
      <div class="modal-dialog generatePopup" id="gameDemoModalPopup">
        <div class="modal-content" id="myModalContentGenerate2">
          <div class="card" id="generatePopupCard2">
            <div class="p-0 modal-header rm-border" id="generatePopupHeader2">
              <div class="invitesuccessmodal-close-icon" data-dismiss="modal" (click)="closeDemoModal()" id="inviteSuccessModalCloseIcon2">
              </div>
            </div>
            <div class="modal-body invitesuccess-panel p-0" id="bodyPopupPanel">
              <iposcen-game-demos></iposcen-game-demos>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> 
</ng-template>  
<div class="blur" *ngIf="showRetailGif" id="showRetailGifDiv">
  <div class="progress-loader" id="progressLoaderDiv">
    <div class="card-loading" id="cardLoadingDiv">
      <div class="card-spinner" id="cardSpinnerDiv">
        <div class="spinner-border text-primary" [ngClass]="{'loader':showRetailGif}" role="status" id="spinnerBorderDiv">
          <span class="visually-hidden loading-message"></span>
        </div>
      </div>
      <div class="switch-text" id="switchTxtRetailDiv">
        <span i18n="@@standard-download.switch-retail-hq">Switching Retail HQ</span>
      </div>
    </div>
  </div>
</div>
<ng-template #downloadDetails>
  <ng-container *ngIf="isGenerating?.status === download">
    <div class="download-details-conatiner" id="downloadDetailsCon">
      <div class="heading" id="isGeneratingHeading">{{isGenerating?.packageFileName}}{{isGenerating?.extention}}</div>
      <div class="subheading" id="isGeneratingDate">
        <span i18n="@@standard-download.last-generated-on">Last generated on {{isGenerating?.date | dateFormat: "changeToLocalTime"}}</span>
      </div>
    </div>
    <button class="btn btn-primary" (click)='downloadConnectedUserPackage()'>
      <span i18n="@@standard-download.download-package">Download Package</span>
    </button>
  </ng-container>
  <div class="download-details-conatiner" *ngIf="isGenerating?.status === error" id="downloadConStatusErr">
    <div class="subheading text-err pt-2" id="subHeadingTxtErr">
      <span class="errIcon pr-2"></span>
      <span>{{PKG_DOWNLOAD_ERROR}}</span>
    </div>
  </div>
</ng-template>
<iposcen-spinner-overlay *ngIf="isDataLoading"></iposcen-spinner-overlay>